// extracted by mini-css-extract-plugin
export default {"user-table":"UserDetail_user-table__tEiUZ"};